import React from 'react';
import { Button, Popover } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { SWEETSPOT_TERMS, type SweetSpotTerm, type SweetSpotTermKey } from './sweetSpotTerminology';
import './SweetSpotProfessional.css';

type HelpProps = { term: SweetSpotTermKey; onOpenDetails?: () => void; className?: string };
type ContextHelpProps = { title: string; summary: string; detail?: React.ReactNode; onOpenDetails?: () => void; className?: string };

function HelpContent({ term, detail, onOpenDetails }: { term: SweetSpotTerm; detail?: React.ReactNode; onOpenDetails?: () => void }) {
  return <div className="sweetspot-help-content">
    <div>{term.summary}</div>
    {(detail || term.detail) && <div className="sweetspot-help-detail">{detail || term.detail}</div>}
    {onOpenDetails && <Button type="link" size="small" onClick={onOpenDetails}>查看详细说明</Button>}
  </div>;
}

export function SweetSpotContextHelp({ title, summary, detail, onOpenDetails, className }: ContextHelpProps) {
  const term: SweetSpotTerm = { title, summary };
  return <Popover title={title} content={<HelpContent term={term} detail={detail} onOpenDetails={onOpenDetails} />} trigger="click" placement="top">
    <Button type="text" size="small" className={`sweetspot-help-button${className ? ` ${className}` : ''}`} icon={<QuestionCircleOutlined />} aria-label={`查看${title}说明`} />
  </Popover>;
}

export default function SweetSpotHelp({ term, onOpenDetails, className }: HelpProps) {
  const definition = SWEETSPOT_TERMS[term];
  return <Popover title={definition.title} content={<HelpContent term={definition} onOpenDetails={onOpenDetails} />} trigger="click" placement="top">
    <Button type="text" size="small" className={`sweetspot-help-button${className ? ` ${className}` : ''}`} icon={<QuestionCircleOutlined />} aria-label={`查看${definition.title}说明`} />
  </Popover>;
}
